import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ConfirmationService, Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-fornecedor-listar',
  templateUrl: './fornecedor-listar.component.html',
  styleUrls: ['./fornecedor-listar.component.scss']
})
export class FornecedorListarComponent extends AdmihairBaseComponent implements OnInit {

  empresaSelecionada?: Empresa;
  fornecedores: Fornecedor[] = [];
  loadingFornecedores: boolean = true;
  @ViewChild('filter') filter!: ElementRef;

  constructor(private fornecedorService: FornecedorService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService,) {
    super(erroService, utilStorageService)
  }


  ngOnInit(): void {
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarFornecedores();
    }
  }

  listarFornecedores() {
    this.fornecedorService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Contrato[]) => {
        this.fornecedores = data;
        this.loadingFornecedores = false;
      },
      error: (err: any) => {
        this.loadingFornecedores = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  excluirFornecedor(fabricanteId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.fornecedorService.excluir(fabricanteId).subscribe({
          next: () => {
            this.loadingFornecedores = true;
            this.listarFornecedores();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.loadingFornecedores = false;
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }


  editarFornecedor(id: number) {
    this._router.navigate(["/apps/fornecedor/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalharFornecedor(id: number) {
    this._router.navigate(["/apps/fornecedor/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_FORNECEDOR');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_FORNECEDOR');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_FORNECEDOR');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_FORNECEDOR');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_FORNECEDOR');
  }

}
